import { render, staticRenderFns } from "./index.vue?vue&type=template&id=bba5d7ce&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=bba5d7ce&lang=scss"
import style1 from "./index.vue?vue&type=style&index=1&id=bba5d7ce&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bba5d7ce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\华水\\hsmanagementsystem\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bba5d7ce')) {
      api.createRecord('bba5d7ce', component.options)
    } else {
      api.reload('bba5d7ce', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=bba5d7ce&scoped=true", function () {
      api.rerender('bba5d7ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/buildertables/index.vue"
export default component.exports